module.exports = Object.freeze({
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  RESET: 'RESET',
  INITIALIZE: 'INITIALIZE',
  TITLE: 'TITLE',
  LIVE_CONFIRMATION: 'LIVE_CONFIRMATION',
  RESEND_CONFIRMATION: 'RESEND_CONFIRMATION'
})
